import React, { useMemo, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';

import Traductor from 'components/Traductor';

const Table = ({ options, loading, headers, RowComponent, items, ...rest }) => {
    const t = useMemo(() => new Traductor(), []);
    const isMobile = useMediaQuery({
        maxDeviceWidth: 600,
    });
    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);
    return (
        <div className="c-table-wrapper">
            <table style={{ borderCollapse: 'collapse' }}>
                <caption>
                    {options?.caption || t.getTraduction('VehiclesTable')}
                </caption>
                <thead>
                    <tr>
                        {headers?.map((e, i) => (
                            <th
                                key={`${e}${i}`}
                                className={`u-pv u-text-muted ${
                                    e?.className || ''
                                }`}
                                style={{ border: 'none' }}
                            >
                                {e?.tooltip ? (
                                    <span
                                        className={`${
                                            isMobile
                                                ? 'u-break-words'
                                                : 'u-ws-nowrap'
                                        }`}
                                    >
                                        {e.text}{' '}
                                        <button
                                            type="button"
                                            className="c-icon c-info-icon js-tooltip c-icon--[semantic-info]"
                                            data-tippy-content={e.tooltip}
                                            data-tippy-placement="top"
                                        />
                                    </span>
                                ) : (
                                    e?.text || e
                                )}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className={`u-pale-border`}>
                    {items?.map((e, i) => (
                        <RowComponent key={`${e}${i}`} item={e} {...rest} />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Table;
